/**
 * index.ts - UI preference modules
 * 
 * CHANGE HISTORY:
 * - 251031_1600 [pending] danielbeer: Added draggr and formr
 * - 251031_1540 [pending] danielbeer: Initial creation
 */

export { panelrModule } from './panelr';
export { commandrModule } from './commandr';
export { promtrModule } from './promptr';
export { draggrModule } from './draggr';
export { formrModule } from './formr';

import { panelrModule } from './panelr';
import { commandrModule } from './commandr';
import { promtrModule } from './promptr';
import { draggrModule } from './draggr';
import { formrModule } from './formr';

export const uiModules = [
  panelrModule,
  commandrModule,
  promtrModule,
  draggrModule,
  formrModule
];

export default uiModules;
